import React, { useCallback } from 'react';
import AgGrid from '../../common/AgGrid/index.jsx';


export default function Grid({gridRef, settings, className, customStyles = {}, gridOptions = {}}) {
  const doesExternalFilterPass = useCallback((node) => {
    const nodeIndex = parseInt(node.id)
    const rangeFrom = settings.range_from || 1;
    const rangeTo = settings.range_to || Infinity;

    return (nodeIndex >= rangeFrom -1 && nodeIndex < rangeTo);
  }, [settings.range_from, settings.range_to]);

  const isExternalFilterPresent = useCallback(() => {
    return true;
  }, []);

  return (<>
    <div
      className={`grid-theme ${className}`}
      style={{
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        paddingBottom: '1rem',
        height: 'calc(90vh - 100px)',
        ...customStyles
      }}
    >
      <AgGrid
        ref={gridRef}
        isExternalFilterPresent={isExternalFilterPresent}
        doesExternalFilterPass={doesExternalFilterPass}
        loading={false}
        {...gridOptions}
      />
    </div>
  </>);
};
